import type { RootState } from '../index';

const s = (state: RootState) => state.auth;

export const selectIsAuthenticated = (state: RootState) => s(state).isAuthenticated;
export const selectCurrentUser = (state: RootState) => s(state).user;
export const selectAuthLoading = (state: RootState) => s(state).loading;
export const selectAuthError = (state: RootState) => s(state).error;
